import SignEvent2 from "../../../../src/events/2021/12/event-sign2/main";
import * as React from 'react';
export default {
  SignEvent2,
  React
};